import { YearOption } from "../types";


export const FINANCIAL_YEAR_OPTIONS: YearOption[] = [
  { option: '01 Jan - 31 Dec', value: 'CALENDAR' },
  { option: '01 Apr - 31 Mar', value: 'FINANCIAL' },
];